module.exports = __webpack_public_path__ + "img/Mfooter-Rectangle.88bab93e.png";